import type { ReactNode } from 'react';
import { Info } from 'lucide-react';
import { cn } from './cn';

/** Un encadré sable, pour ce qui est provisoire : mode démo, écran à venir. */
export function NoteMaquette({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'flex gap-2.5 rounded-xl border border-dashed border-note-border bg-note-bg px-3.5 py-2.5 text-xs text-note',
        className
      )}
    >
      <Info className="mt-px size-4 shrink-0" aria-hidden />
      <div>{children}</div>
    </div>
  );
}
